import Up from "../../../assets/icon/NewsIcons/NewsUpGreen"

const MarketLookItem = () => {
    return(
        <div className="m-[10px] flex justify-between items-center">
            <div className="flex justify-start items-center">
                <div className="flex justify-start items-center ">
                    <p className="font-IRANYekanMedium text-[10px]" >
                    3/21
                    </p>
                    <p className="font-IRANYekanMedium text-[10px] mx-1">
                    -
                    </p>
                    <p className="font-IRANYekanMedium text-[10px]">
                    18:59
                    </p>
                </div>
                <div>
                    <p className="font-IRANYekanMedium text-[10px] mr-[10px] pr-[10px] border-r-[1px] border-lightGray">
                    دلار مبادله ای
                    </p>
                </div>
            </div>
            <div className="flex justify-start items-center">
                <div className="flex justify-start items-center">
                    <p className="font-IRANYekanBold text-[10px]">
                    45,508
                    </p>
                    <p className="font-IRANYekanMedium text-[8px] mr-1">
                    تومان
                    </p>
                </div>
                <div className="mr-4">
                    <Up/>
                </div>
            </div>
        </div>
    )
}

export default MarketLookItem;